<template>
  <div id="app">
    <Download />
  </div>
</template>

<script type="application/javascript">
const Download = require('./Download.vue').default
export default {
  name: 'app',
  components: {
    Download
  }
}
</script>

<style>
* {margin: 0;padding: 0;}
a{outline:none;text-decoration:none;}
em,i{font-style:normal;}
ol, ul ,li{list-style: none;}
.clearfix{overflow:auto;_height:1%;}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
</style>
